<div class="formgrid grid">
  <div class="field col mb-0">
    <label *ngIf="this.showLabels" class="mb-0">
      {{ this.customerLabel }}
    </label>

    <!-- <span *ngFor="let customer of customers"> {{ customer.name }}, </span> -->
    <!-- Debounce this filtering-->

    <span class="p-fluid">
      <ng-template #multiSelection>
        <p-multiSelect
          (onChange)="handleCustomerSelection($event)"
          (onFilter)="onSearch($event.filter)"
          (onPanelShow)="showPanel()"
          [(ngModel)]="selectedCustomers"
          [emptyFilterMessage]="loadingText"
          [emptyMessage]="
            searchTarget == 'Vendor'
              ? 'Loading Vendors...'
              : 'Loading Customers...'
          "
          [options]="customers"
          [placeholder]="placeHolderText"
          [filter]="true"
          [maxSelectedLabels]="1"
          [filterValue]="filterText"
          filterMatchMode="contains"
          optionLabel="name"
          selectedItemsLabel="{0} Selected"
          appendTo="body"
        >
          <ng-template pTemplate="header">
            <ng-container *ngTemplateOutlet="filterHeader"></ng-container>
          </ng-template>
          <ng-template pTemplate="footer">
            <div class="grid p-justify-between align-items-center p-5">
              <div class="col">
                {{ selectedCustomers?.length || 0 }} selected
              </div>
              <div class="col text-right">
                <button
                  class="p-button-outlined p-button-secondary"
                  icon="pi pi-times"
                  label="Clear"
                  pButton
                  pRipple
                  style="float: left"
                  (click)="clearSelection()"
                  [disabled]="!selectedCustomers?.length"
                ></button>
              </div>
            </div>
          </ng-template>

          <ng-template let-customer pTemplate="item">
            <div style="font-size: 18px">
              <i
                [class]="
                  customer.type == 'Trader'
                    ? 'material-icons-round mi-storefront'
                    : customer.type == 'Consumer'
                    ? 'material-icons-round mi-shopping-bag'
                    : 'material-icons-round mi-business'
                "
                style="vertical-align: middle"
              ></i>
              {{ customer.name }}
            </div>
          </ng-template>
        </p-multiSelect>
      </ng-template>

      <ng-container *ngIf="singleSelection; else multiSelection">
        <p-dropdown
          (onChange)="handleCustomerSelection($event)"
          (onFilter)="onSearch($event.filter)"
          (onShow)="showPanel()"
          [(ngModel)]="selectedCustomer"
          [emptyFilterMessage]="loadingText"
          [emptyMessage]="
            searchTarget == 'Vendor'
              ? 'Loading Vendors...'
              : 'Loading Customers...'
          "
          [options]="customers"
          [placeholder]="placeHolderText"
          [filter]="true"
          [filterValue]="filterText"
          filterMatchMode="contains"
          optionLabel="name"
          selectedItemsLabel="{0} customer(s) selected"
          appendTo="body"
          [showClear]="true"
        >
          <ng-template pTemplate="empty">
            {{
              !customers?.length
                ? searchTarget == 'Vendor'
                  ? 'Loading Vendors...'
                  : 'Loading Customers...'
                : 'No results matched your filter, clear your filter and try again.'
            }}
          </ng-template>

          <ng-template pTemplate="header">
            <ng-container *ngTemplateOutlet="filterHeader"></ng-container>
          </ng-template>
          <ng-template let-customer pTemplate="item">
            <div style="font-size: 18px">
              <i
                [class]="
                  customer.type == 'Trader'
                    ? 'material-icons-round mi-storefront'
                    : customer.type == 'Consumer'
                    ? 'material-icons-round mi-shopping-bag'
                    : 'material-icons-round mi-business'
                "
                style="vertical-align: middle"
              ></i>
              {{ customer.name }}
            </div>
          </ng-template>
        </p-dropdown>
      </ng-container>
    </span>
  </div>
</div>

<ng-template #filterHeader>
  <div class="field col block" *ngIf="showTypes">
    <label *ngIf="this.showLabels" class="mb-0">Status</label>
    <span class="p-fluid">
      <p-dropdown
        [options]="customerTypes"
        [(ngModel)]="selectedType"
        (onChange)="updateCustomerType($event)"
      ></p-dropdown>
    </span>
  </div>
</ng-template>
